<template>
  <div class="notuser-page">
    <img
      class="logo-img"
      width="240"
      height="70"
      src="@/assets/img/logo_landing.png"
      srcset="@/assets/img/logo_landing@2x.png 2x, @/assets/img/logo_landing@3x.png 3x"
      alt="听语logo">
      <div class="tip">
        <div class="first-tip">您不是新用户</div>
        <div class="second-tip">请前往灵云听语APP或官网体验服务！</div>
        <div class="third-tip">rec.aicloud.com</div>
      </div>
      <!-- <div class="tip">您不是新用户</div>
      <div class="tip">请前往灵云听语APP或官网体验服务！</div>
      <div class="address">rec.aicloud.com</div> -->
      <div class="footer">
        或者您可以前往灵云听语APP【我的-分享邀请】邀请好友注册，您最高可获得20小时转写时长！
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
  .notuser-page {
    position: relative;
    height: 100vh;
    padding-top: 394px;
    // background-image: linear-gradient(177deg, rgba(138,208,255,0.88), rgba(52,152,219,0.88), rgba(12,128,205,0.88));
    background-image: url(~@/assets/img/bg_landing@2x.png);
    background-size: 100%;
    background-repeat: no-repeat;
    background-color: #d2b2ff;
    & .logo-img {
      position: absolute;
      top: 33px;
      left: 40px;
      width: 240px;
      height: 70px;
    }
    // & .tip {
    //   font-size: 36px;
    //   font-family: PingFang SC;
    //   font-weight: 500;
    //   color: #fff;
    //   line-height: 54px;
    //   &:nth-of-type(2) {
    //     margin-bottom: 100px;
    //   }
    // }
    .tip {
      position: absolute;
      top: 400px;
      left: 50%;
      padding: 50px 2px;
      text-align: center;
      transform: translateX(-50%);
      width: 700px;
      // height: 106px;
      background-color: rgba(255, 255, 255, .46);
      border-radius: 30px;
      color: #5B8BE4;
      div {
        font-size: 36px;
      }
      .first-tip {
        margin-bottom: 30px;
      }
      .second-tip {
        margin-bottom: 50px;
      }
      .third-tip {
        margin-bottom: 10px;
        font-size: 28px;
      }
    }
    & .address {
      font-size: 40px;
      font-weight: 500;
      color: #fff;
      line-height: 32px;
    }
    & .footer {
      position: absolute;
      bottom: 40px;
      left: 0;
      padding: 0 70px;
      font-size: 24px;
      font-weight: 400;
      color: #fff;
      line-height: 36px;
      text-align: left;
    }
  }
</style>
